class employeesDataFormatter {

  static assemble(data) {
    let user = buildUser(data);
    let delegatedUsers = buildDelegated(data);
    let employees = [];
    employees.push(user);
    employees = [...employees, ...delegatedUsers];
    return employees;
  }

}

function buildUser(data) {
  let formattedCards = formatCardsMonth(data.cards);
  let employee = {
    profile: data.getProfile(),
    cards: formattedCards,
  };
  return employee;
}

function buildDelegated(data) {
  let employees = [];
  data.delegations.forEach((delegation) => {
    let employee = {
      profile: delegation.profile,
      cards: delegation.cards,
    };
    employees.push(employee);
  });
  return employees;
}

function formatCardsMonth(cards) {
  let cardsFormat = [];
  cards.forEach((card) => {
    if(card.enjoymentMonth.toString().length === 1){
      card.enjoymentMonth = '0' + card.enjoymentMonth.toString();
    }
    cardsFormat.push(card);
  });

  return cardsFormat;

}

export default employeesDataFormatter;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/domain/formatters/employeesDataFormatter.js